<template>
  <div>
    <Breadcrumb title="จัดการ Course Outline"/>
    <ContentBox
      :size="{ height: '65' }"
    >
      <template slot="tools">
        <BackButton />
      </template>

      <div class="content">
        <div v-if="data">
          <transition name="fade">
            <div class="editor" v-if="editor">
              <component :is="editor"
                @call-editor="handleEditor"
                :mode="editorMode"
                :edata="editorData"
                :methods="methods"
              ></component>
            </div>
          </transition>

          <BlockGroup inline>
            <CourseOutlineNote v-bind="note" style="width: 50%" />
            <CourseOutlineAssessments
              v-bind="assessments"
              @call-editor="handleEditor"
              :methods="methods"
              style="width: 50%"
            />
          </BlockGroup>

          <BlockGroup>
            <CourseOutlineInstruction
              v-bind="instruction"
              :data="data"
              @call-editor="handleEditor"
            />
          </BlockGroup>

          <BlockGroup>
            <CourseOutlineUnits
              v-bind="units"
              :methods="methods"
              @call-editor="handleEditor"
            />
          </BlockGroup>

          <BlockGroup>
            <CourseOutlineTextBooks
              :data="data"
              :books="books"
              :methods="methods"
              @call-editor="handleEditor"
            />
          </BlockGroup>

        </div>
        <div v-else>
          Loading...
        </div>
      </div>
    </ContentBox>
  </div>
</template>

<script>
import Breadcrumb from "@/components/common-ui/page-element/breadcrumb/index.vue";
import ContentBox from "@/components/common-ui/content-box/index.vue";
import BackButton from "@/components/common-ui/page-element/back-button/index.vue";
import BlockGroup from "@/components/common-ui/block-group/index.vue";

import CourseOutlineNote from "./subcomponent/course-outline-note.vue";
import CourseOutlineAssessments from "./subcomponent/course-outline-assessment.vue";
import CourseOutlineInstruction from "./subcomponent/course-outline-instruction.vue";
import CourseOutlineUnits from "./subcomponent/course-outline-units.vue";
import CourseOutlineTextBooks from "./subcomponent/course-outline-textbooks.vue";
import {
  CourseOutlineNote_DataTemplate,
  CourseOutlineAssessments_DataTemplate,
  CourseOutlineInstruction_DataTemplate,
  CourseOutlineUnits_DataTemplate,
  CourseOutlineTextBooks_DataTemplate
} from "./data-template";

export default {
  props: {
    // data: Object,
    // methods: Object,
    // actions: Object,
    mode: {
      type: String,
      default: ""
    },
    data: {
      type: Object,
      default: () => null
    },
    methods: Object
  },
  data() {
    return {
      editor: null,
      editorMode: "",
      editorData: {},
    }
  },
  computed: {
    note() { return CourseOutlineNote_DataTemplate(this.data) },
    assessments() { return CourseOutlineAssessments_DataTemplate(this.data) },
    instruction() { return CourseOutlineInstruction_DataTemplate(this.data) },
    units() { return CourseOutlineUnits_DataTemplate(this.data) },
    books() { return CourseOutlineTextBooks_DataTemplate(this.data)}
  },
  components: {
    // ContentGroup,
    Breadcrumb,
    ContentBox,
    BackButton,
    BlockGroup,
    CourseOutlineNote,
    CourseOutlineAssessments,
    CourseOutlineInstruction,
    CourseOutlineUnits,
    CourseOutlineTextBooks,
    "create-course-outline": () => import("./subcomponent/create-course-outline.vue"),
    "edit-assessment": () => import("./subcomponent/edit-assessment.vue"),
    "edit-instruction": () => import("./subcomponent/edit-instruction.vue"),
    "edit-unit": () => import("./subcomponent/edit-unit.vue"),
    "edit-textbooks": () => import("./subcomponent/edit-textbooks.vue"),
  },
  methods: {
    handleEditor(name, params) {
      let mode = "";
      if (params) {
        mode = params.mode || "";
      }
      if (name !== "close" && name !== "" && name && name !== null) {
        this.editor = name;
        this.editorMode = mode;
        this.editorData = params.data;
      } else {
        this.editor = null;
        if (this.mode === "add") {
          this.$router.push({
            name: "course-outline"
          })
        }
      }
      this.methods.reloadData();
    },
  },
  mounted() {
    if (this.mode === 'add') {
      this.handleEditor("create-course-outline");
    }
  }
}
</script>

<style lang="scss">
/*.section-icon {
  font-size: 3rem;
}

.section-title {
  font-size: 1.4rem;
  line-height: 1rem;
  margin-left: 10px;
}

.inline {
  display: inline-flex;
}

.editor {
  display: flex;
  position: absolute !important;
  width: 100%;
  height: 100%;
  padding: 10%;
  background: #efefefd9;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 49999;
  background: rgba(236, 236, 236, 0.65);
  backdrop-filter: blur(6px);
  // &:before {
    // box-shadow: inset 0 0 2000px rgba(255, 255, 255, .5);
    // filter: blur(10px);
  // }

  & .close-button {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}

.fade-enter-active {
  transition: all .2s ease;
}
.fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.fade-enter, .fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}*/
</style>
